var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import CancelDispute from '../../pages/CancelDispute';
import { ModalType } from '../../redux/ui/typings';
import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import ErrorBoundary from '../../ui/atoms/ErrorBoundary';
import DisputesWrapperError from '../../ui/molecules/DisputeWrapperError';
import AdditionalInfo from '../../pages/AdditionalInfo';
import Questionnaire from '../../pages/Questionnaire';
import DisputeInfo from './DisputeInfo';
export var LoaderWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 90vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n"], ["\n  height: 90vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n"])));
export var AccordionWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"])));
export var BreadCrumbContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  overflow: hidden;\n  border-top-right-radius: 10px;\n  border-top-left-radius: 10px;\n  @media ", " {\n    overflow: auto;\n    border-radius: 0;\n  }\n"], ["\n  overflow: hidden;\n  border-top-right-radius: 10px;\n  border-top-left-radius: 10px;\n  @media ", " {\n    overflow: auto;\n    border-radius: 0;\n  }\n"])), query.lessThanMedium);
export var DisputeModal = function (_a) {
    var modalType = _a.modalType;
    var modalComponent;
    switch (modalType) {
        case ModalType.CancelDispute:
            modalComponent = _jsx(CancelDispute, {});
            break;
        case ModalType.DisputeInfo:
            modalComponent = _jsx(DisputeInfo, {});
            break;
        case ModalType.AdditionalInfo:
            modalComponent = _jsx(AdditionalInfo, {});
            break;
        case ModalType.Questionnaire:
            modalComponent = _jsx(Questionnaire, {});
            break;
        default:
            return null;
    }
    return (_jsx(ErrorBoundary, __assign({ fallback: _jsx(DisputesWrapperError, { modalType: modalType }) }, { children: modalComponent })));
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=subcomponents.js.map